export function min(num1: number, num2: number): number {
  return num1 < num2 ? num1 : num2;
}

export function max(num1: number, num2: number): number {
  return num1 > num2 ? num1 : num2;
}
